/**
 * Front end interactivity for the table filter blocks.
 *
 * @package
 */

document.addEventListener('DOMContentLoaded', function () {
	const filterFormBlocks = document.querySelectorAll(
		'.paragon-table-filter-block'
	);

	// Loop through each filter form block and add event listeners.
	filterFormBlocks.forEach((formBlock) => {
		const form = formBlock.querySelector('.pdm-filters');
		const searchInput = form.querySelector('.pdm-filters__input');
		const filterSubmit = form.querySelector('.pdm-filters__button');
		const resetButton = form.querySelector('.pdm-filters__button--reset');
		const tableId = form.getAttribute('data-filter-target');
		const table = document.getElementById(tableId);

		if (table) {
			filterSubmit.addEventListener('click', (event) =>
				handleFilterSubmit(event, searchInput, table)
			);
			resetButton.addEventListener('click', (event) =>
				handleFormReset(event, searchInput, table)
			);
		}
	});
});

/**
 * Handles the filter submit event.
 * Prevents default form submission and fires the filtering function, using view transitions if available.
 *
 * @param {Event}            event       - The event object.
 * @param {HTMLInputElement} searchInput - The search input element.
 * @param {HTMLTableElement} table       - The table element to filter.
 */
function handleFilterSubmit(event, searchInput, table) {
	event.preventDefault();

	if (!document.startViewTransition) {
		updateFilteredRows(searchInput, table);
		return;
	}

	document.startViewTransition(() => updateFilteredRows(searchInput, table));
}

/**
 * Handles the form reset event.
 * Fires the reset function, using view transitions if available.
 *
 * @param {Event}            event       - The event object.
 * @param {HTMLInputElement} searchInput - The search input element.
 * @param {HTMLTableElement} table       - The table element to reset.
 */
function handleFormReset(event, searchInput, table) {
	if (!document.startViewTransition) {
		resetFilteredRows(searchInput, table);
		return;
	}

	document.startViewTransition(() => resetFilteredRows(searchInput, table));
}

/**
 * Updates the filtered rows based on the search input value.
 * Hides rows that do not match the search criteria.
 *
 * @param {HTMLInputElement} searchInput - The search input element.
 * @param {HTMLTableElement} table       - The table element to filter.
 */
function updateFilteredRows(searchInput, table) {
	const filterValue = searchInput.value.toLowerCase();
	const rows = table.querySelectorAll('tbody tr');

	rows.forEach((row) => {
		const rowText = row.textContent.toLowerCase();
		if (rowText.includes(filterValue)) {
			row.style.display = '';
		} else {
			row.style.display = 'none';
		}
	});
}

/**
 * Resets the filtered rows to their original state.
 * Displays all rows and focuses on the search input.
 *
 * @param {HTMLInputElement} searchInput - The search input element.
 * @param {HTMLTableElement} table       - The table element to reset.
 */
function resetFilteredRows(searchInput, table) {
	const rows = table.querySelectorAll('tbody tr');
	rows.forEach((row) => {
		row.style.display = '';
	});
	searchInput.focus();
}
